import { TextField } from '@radix-ui/themes';
import { Path } from 'react-hook-form';
import { CollectionMetadata } from '../types';
import { MetadataFieldWrapper } from './MetadataFieldWrapper';
import { useMetadataField } from '../hooks/useMetadataField';

interface TextMetadataFieldProps {
    name: Path<CollectionMetadata>;
}

export const TextMetadataField = ({ name }: TextMetadataFieldProps) => {
    const hookData = useMetadataField<string>({ name });
    const { field } = hookData;

    return (
        <MetadataFieldWrapper {...hookData}>
            <TextField.Root size='2' {...field} />
        </MetadataFieldWrapper>
    );
};
